import {bootstrap} from "vue-gtag";
<template>
  <div class="wishlist-btn-container">
    <div v-if="!isButton" class="wishlist-icon">
      <i
        v-if="isProductInWishlist(product)"
        @click.stop="toggle(product)"
        class="material-icons salmon"
      >
        favorite
      </i>
      <i v-else @click.stop="toggle(product)" class="material-icons">
        favorite
      </i>
    </div>
    <button class="button black" v-if="isButton" @click.stop="toggle(product)">
      <span v-if="!isProductInWishlist(product)">
        {{ "wishlist.titles.add_to" | translate }}
      </span>
      <span v-if="isProductInWishlist(product)">
        {{ "wishlist.titles.remove" | translate }}
      </span>
      <i
        class="material-icons"
        :class="{ salmon: isProductInWishlist(product) }"
        >favorite</i
      >
    </button>
  </div>
</template>

<script>
import { wishlistMethods } from "../../mixins";
export default {
  name: "wishlist-component",
  props: {
    product: {
      required: true,
      type: Object
    },
    isButton: Boolean
  },
  mixins: [wishlistMethods],
  methods: {
    toggle(product) {
      if (this.$cookies.get("accept-cookie-policy")) {
        this.isProductInWishlist(product)
          ? this.$gtag.event("productWishlisted", {
              value: product._id,
              event_category: "wishlist",
              event_label: "product"
            })
          : this.$gtag.event("productWishlistRemoved", {
              value: product._id,
              event_category: "wishlist",
              event_label: "product"
            });
      }
      this.toggleProductInWishlist(product);
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.wishlist-icon {
  color: black;
  background-color: white;
  border-radius: 50%;
  height: 1.5rem;
  width: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 8px rgb(0, 0, 0, 0.25);
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.25);
  }
}

.material-icons {
  font-size: $font-base;

  &.salmon {
    color: $brand-salmon;
  }
}

.button {
  width: 100%;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-size: $font-sm;
    font-weight: 500;
  }

  .material-icons {
    margin-left: 0.5rem;
  }
}
</style>
